import { Button } from "react-aria-components";
import IconCases from "../../../assets/icons/icon-cases-orange.svg"
import IconSpecimen from "../../../assets/icons/icon-specimens-orange.svg"
import IconContainer from "../../../assets/icons/icon-containers-orange.svg"
import * as Navigation from "../../../modules/Navigation";
import { useNavigate } from "react-router";
import { EntityNames } from "../../../enums/EntityNames";
import InventoryPage from "./InventoryPage";
import React from "react";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";

export default function InventoryLandingView() {
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    const navMenuItems = {
        Inventory_Containers: <Button className={"landing-page__button  cell small-6"} onPress={() => handleClick(EntityNames.containers)}>
            <img alt='' src={IconContainer} />
            <h2 className={"landing-page__button-text"}>Containers</h2>
        </Button>,
    };

        

    function handleClick(entityName: string) {
        Navigation.Inventory.navigate(navigate, entityName)
    }

    return (<>
        <div className="grid-x grid-margin-x padding__top-bottom--s padding__left-right--l">
            {
                hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Cases_And_Ranges) ? 
                    <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.rangesAndCases)}>
                        <img alt='' src={IconCases} />
                        <h2 className={"landing-page__button-text"}>Cases</h2>
                    </Button> : null
            }
            {
                hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Specimens) ? 
                    <Button className={"landing-page__button  cell small-6"} onPress={() => handleClick(EntityNames.specimens)}>
                        <img alt='' src={IconSpecimen} />
                        <h2 className={"landing-page__button-text"}>Part Cases</h2>
                    </Button> : null
            }
            {
                hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Inventory_Containers) ? navMenuItems.Inventory_Containers : null
            }
        </div>
    </>)
}
